import { defineDefaultEnumValue, defineEnumClampFunction } from 'src/lib/enum';

export const APPLICATION_BAR_HEIGHT = 66;

export const DOCUMENT_SCORE_PANEL_WIDTH = 54;
export const DOCUMENT_SCORE_PANEL_HEIGHT = 57;
export const DOCUMENT_LOCKED_SCORE_PANEL_HEIGHT = 30;
export const DOCUMENT_SCORE_SIZE = 35;
export const DOCUMENT_GENERATION_FORM_WIDTH = 429;
export const DOCUMENT_LEFT_PANEL_WIDTH = 510;

export const BLOG_ACTIONS_BAR_HEIGHT = 54;
export const LONG_FORM_ACTIONS_BAR_HEIGHT = 54;
export const LONG_FORM_INNER_CONTENT_WIDTH = 1007;
export const LONG_FORM_SECTION_WIDTH = 815;
export const TEXT_DETAILS_PANEL_WIDTH = 580;

export const TABLE_PAGINATION_HEIGHT = 55;

export const BANNER_PERFORMANCE_PREDICTIONS_HEIGHT = 48;
export const BANNER_WEBINAR_HEIGHT = 56;

/**
 * "Insights" panel tab
 * @enum {string}
 * @property {TEXT_DETAILS_PANEL_TAB} DEFAULT - default generation tool
 * @property {EnumClampFunction<TEXT_DETAILS_PANEL_TAB>} clamp - function that clamps the value to the enum
 */
export const TEXT_DETAILS_PANEL_TAB = {
  performance: 'performance',
  brandPolicy: 'brandPolicy',
};
defineDefaultEnumValue(TEXT_DETAILS_PANEL_TAB, TEXT_DETAILS_PANEL_TAB.brandPolicy);
defineEnumClampFunction(TEXT_DETAILS_PANEL_TAB, TEXT_DETAILS_PANEL_TAB.brandPolicy);

const TEXT_DETAILS_PANEL_TAB_LABELS = {
  [TEXT_DETAILS_PANEL_TAB.performance]: 'Performance',
  [TEXT_DETAILS_PANEL_TAB.brandPolicy]: 'Brand & policy',
};
export const getTextDetailsPanelTabLabel = (tab) => TEXT_DETAILS_PANEL_TAB_LABELS[tab] || '';
